export const INDUSTRIES = [
  'Accounting & Auditing', 'Advertising & Marketing', 'Aerospace & Defense', 'Agriculture',
  'Architecture & Planning', 'Automotive', 'Aviation & Airlines', 'Banking & Financial Services',
  'Biotechnology', 'Broadcasting & Media', 'Chemicals', 'Civil Engineering',
  'Construction & Real Estate', 'Consulting', 'Consumer Electronics', 'Consumer Goods & FMCG',
  'Cybersecurity', 'Data Analytics & AI', 'Design & Creative Services', 'E-commerce',
  'Education & Training', 'Electrical & Electronics Manufacturing', 'Energy & Utilities',
  'Entertainment & Gaming', 'Environmental Services', 'Events & Conferences', 'Fashion & Apparel',
  'Film & Television', 'Fintech', 'Food & Beverage', 'Freight & Shipping',
  'Government & Public Sector', 'Healthcare & Medical', 'Hospitality & Tourism',
  'Human Resources & Staffing', 'Import & Export', 'Industrial Automation',
  'Information Technology', 'Insurance', 'Interior Design', 'Investment & Venture Capital',
  'Islamic Finance', 'Jewelry & Luxury Goods', 'Legal Services', 'Logistics & Supply Chain',
  'Management Consulting', 'Manufacturing', 'Marine & Maritime', 'Market Research',
  'Mechanical Engineering', 'Mining & Metals', 'Music & Performing Arts', 'Nanotechnology',
  'Non-Profit & NGO', 'Oil & Gas', 'Outsourcing & Offshoring', 'Packaging & Containers',
  'Petrochemicals', 'Pharmaceutical', 'Photography & Videography', 'Plastics & Rubber',
  'Printing & Publishing', 'Private Equity', 'Professional Services',
  'Public Relations & Communications', 'Quality Assurance & Testing', 'Railways & Metro',
  'Real Estate & Property Management', 'Renewable Energy & Clean Tech', 'Research & Development',
  'Restaurants & Food Service', 'Retail', 'Robotics', 'SaaS & Cloud Computing',
  'Security & Investigation', 'Semiconductors', 'Social Enterprise', 'Software Development',
  'Sports & Recreation', 'Telecommunications', 'Textiles & Garments',
  'Translation & Localization', 'Transportation & Logistics', 'Travel & Tourism',
  'Veterinary & Animal Care', 'Warehousing & Distribution', 'Waste Management & Recycling',
  'Water & Desalination', 'Wholesale Trade', 'Other',
] as const;
